import { useContext, useMemo } from "react";
import { ToastContext } from "@/context/ToastContext";

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) throw new Error("useToast must be used within a ToastProvider");

  // Helper functions with default settings
  const helpers = useMemo(
    () => ({
      showSuccessToast: (message: string, header: string = "Success") => {
        context.showToast({
          type: "success",
          header,
          message,
          duration: 3000,
          placement: "top-right",
        });
      },
      showErrorToast: (message: string, header: string = "Error") => {
        context.showToast({
          type: "error",
          header,
          message,
          duration: 5000,
          placement: "top-right",
        });
      },
    }),
    [context],
  );

  return { ...context, ...helpers };
};
